module.exports = __webpack_public_path__ + "img/구디 쌀국수.24c6c344.png";